import { useState } from 'react';
import { Star, Shield, Building2, Crown } from 'lucide-react';
import PaketKarti from './components/PaketKarti';
import GuvenBolumu from './components/GuvenBolumu';

const AbonelikSayfasi = () => {
    const [selectedPkg, setSelectedPkg] = useState('PROFESYONEL');

    const packages = [
        {
            name: 'BAŞLANGIÇ',
            price: '11.990',
            period: 'Yıl',
            description: 'Yeni başlayan müteahhitler ve küçük projeler için temel özellikler.',
            icon: Building2,
            features: [
                '1 Aktif İnşaat Projesi',
                'Maksimum 50 Daire',
                '2 Kullanıcı Erişimi',
                'Gelir/Gider Takibi',
                'Temel Raporlama',
                'Mobil Uygulama Erişimi',
                'E-posta Desteği',
            ],
            notIncluded: [
                'Özel Geliştirme Talebi',
                'Çoklu Şube Yönetimi'
            ],
            highlightText: 'Aylık ~999 TL',
            buttonVariant: 'secondary'
        },
        {
            name: 'PROFESYONEL',
            price: '19.990',
            period: 'Yıl',
            description: 'Büyüyen firmalar için limitlere takılmadan tam kapsamlı yönetim.',
            recommended: true,
            icon: Star,
            features: [
                '5 Aktif İnşaat Projesi',
                'Sınırsız Daire Yönetimi',
                '10 Kullanıcı Erişimi',
                'Tüm Başlangıç Özellikleri',
                'Gelişmiş Stok & Malzeme Takibi',
                'Çek & Senet Modülü',
                'Detaylı Karlılık Raporları',
                'WhatsApp & Öncelikli Destek',
                '✨ Özel Geliştirme/Özellik Talebi'
            ],
            // notIncluded removed as requested
            highlightText: 'Aylık ~1.666 TL',
            buttonVariant: 'primary'
        },
        {
            name: 'KURUMSAL',
            price: '39.990',
            period: 'Yıl',
            description: 'Büyük ölçekli projeler, özel entegrasyonlar ve AI gücü.',
            icon: Crown, // Changed icon to Crown for premium feel
            features: [
                'Sınırsız İnşaat Projesi',
                'Sınırsız Daire & Cari',
                '20+ Kullanıcı Erişimi',
                'Tüm Profesyonel Özellikler',
                'Özel Sunucu (On-Premise) Kurulumu',
                'API & Muhasebe Entegrasyonu',
                'Müşteriye Özel Onboarding',
                '7/24 VIP Canlı Destek',
                '🤖 AI Maliyet Tahmini',
                '🤖 AI Tahsilat Analizi',
                '🤖 AI Asistan (Chatbot)'
            ],
            upcomingFeatures: [],
            highlightText: 'Özel Çözümler',
            buttonVariant: 'dark'
        }
    ];

    return (
        <div className="min-h-screen bg-bg-primary py-12 px-4 sm:px-6 lg:px-8">
            {/* Header Section */}
            <div className="text-center max-w-4xl mx-auto mb-16 space-y-4">
                <h2 className="text-orange-600 font-bold tracking-widest uppercase text-sm bg-orange-50 inline-block px-4 py-1 rounded-full border border-orange-100">
                    ABONELİK & FİYATLANDIRMA
                </h2>
                <h1 className="text-4xl sm:text-5xl font-black text-text-primary tracking-tight">
                    İşinizi Büyütmek İçin <span className="text-primary relative inline-block">
                        Doğru Planı
                        <svg className="absolute w-full h-3 -bottom-1 left-0 text-primary opacity-20" viewBox="0 0 100 10" preserveAspectRatio="none">
                            <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" />
                        </svg>
                    </span> Seçin
                </h1>
                <p className="text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed">
                    Şantiyeden finansa tüm süreçlerinizi tek platformda yönetin.
                    <br />
                    <span className="font-medium text-text-primary">Yıllık planlarla %20 tasarruf edin.</span>
                </p>
            </div>

            {/* Pricing Cards */}
            <div className="max-w-7xl mx-auto grid gap-8 lg:grid-cols-3 lg:gap-8 items-stretch">
                {packages.map((pkg) => (
                    <PaketKarti
                        key={pkg.name}
                        pkg={pkg}
                        selected={selectedPkg === pkg.name}
                        onClick={() => setSelectedPkg(pkg.name)}
                    />
                ))}
            </div>

            {/* Trust & Trial Section */}
            <GuvenBolumu />

            {/* FAQ Link or Contact Info could go here */}
            <div className="text-center mt-12 text-sm text-text-muted">
                Sorularınız mı var? <a href="#" className="text-primary font-bold hover:underline">Satış ekibimizle iletişime geçin</a> veya <a href="#" className="text-primary font-bold hover:underline">Sıkça Sorulan Sorular</a>ı inceleyin.
            </div>
        </div>
    );
};

export default AbonelikSayfasi;
